import React from 'react';
import { Stack } from '@mui/material';
import { VTypography } from '@venti-components';
import ProducerPayoutConfigForm from './Form/ProducerPayoutConfigForm';
import { useProducerPayoutConfigPage } from './hook';

const ProducerPayoutConfigPage = ({ producerId }) => {
  const { payoutConfig, handleSubmit, loading } = useProducerPayoutConfigPage(producerId);

  return (
    <Stack width="100%" alignItems="center" gap={3}>
      <VTypography variant="h3" align="center">
        Información Financiera
      </VTypography>
      {!loading && <ProducerPayoutConfigForm payoutConfig={payoutConfig} onSubmit={handleSubmit} />}
    </Stack>
  );
};

export default ProducerPayoutConfigPage;
